import { produce } from 'immer';

import { FilterInternalMarketers } from '../../../actions/marketers/internal/filterInternalMarketers';
import { MarketersState } from '../../../typings/marketers';

export function filterInternalMarketers(state: MarketersState, action: FilterInternalMarketers): MarketersState {
    return produce(state, draft => {
        draft.marketers = draft.allMarketers.filter(({ ownProducts }) => {
            const filter = draft.filter;
            const accessType = filter.access;
            const place = filter.place;

            return (
                filter.products.length === 0 ||
                ownProducts.some(({ productName, access, placeIds }) => {
                    return (
                        filter.products.includes(productName) &&
                        (!accessType || access === accessType) &&
                        (!place || placeIds.includes(place))
                    );
                })
            );
        });
    });
}
